/**
 * cycleContext — Construction du préfixe de contexte cycle pour l'IA.
 *
 * Strictement opt-in : ne renvoie une chaîne non vide que si une phase
 * valide est fournie. Aucun appel réseau, aucune dépendance React.
 * Permet une injection silencieuse dans les payloads IA sans risque
 * de blocage si les données cycle sont absentes.
 */
import type { PhaseInfo } from "@/hooks/useCycleTracking";

export function buildCycleContext(phase: PhaseInfo | null | undefined): string {
  if (!phase) return "";
  try {
    return `[Contexte cycle : ${phase.label}, jour ${phase.day}. ${phase.trainingAdaptation}]`;
  } catch {
    return "";
  }
}
